import { render, staticRenderFns } from "./DueDateButton.vue?vue&type=template&id=58a8c924&scoped=true&"
import script from "./DueDateButton.vue?vue&type=script&lang=ts&"
export * from "./DueDateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8c924",
  null
  
)

export default component.exports